export default __webpack_public_path__ + "24130dfed7293955968c42c567d2cf90.png";